import { DeviceItem } from '@/types/device'
import { parseNumber } from '@/utils/index'
// 设备
export function parseDeviceItem(item: DeviceItem): void {
  // type设备类型 :1 飞机, 3 电池, 4 飞控, 6 无人车, 7 自驾仪
  // item.typeName = ''
  // switch (item.type) {
  //   case 1:
  //     item.typeName = '无人机'
  //     break
  //   case 3:
  //     item.typeName = '电池'
  //     break
  //   case 4:
  //     item.typeName = '飞控'
  //     break
  //   case 6:
  //     item.typeName = '无人车'
  //     break
  //   case 7:
  //     item.typeName = '自驾仪'
  //     break
  //   default:
  //     item.typeName = '未知类型设备'
  // }
  // item.showName = `${item.typeName} ${item.product_definition_name}`
  item.showName = item.name
}

export function parseNetworkPointtItem(it: any): void {
  it.id = it.guid
  switch (it.sub_type) {
    // 自营服务站
    case 'after_sales':
      it.iconSrc = '/images/poi_icon_dss.png'
      it.activedIconSrc = '/images/poi_icon_popup_dss.png'
      break
    // 移动服务站
    case 'after_sales_car':
      it.iconSrc = '/images/poi_icon_dealers.png'
      it.activedIconSrc = '/images/poi_icon_popup_dealers.png'
      break
    // 授权服务站
    case 'auth_warehouse':
      it.iconSrc = '/images/poi_icon_mss.png'
      it.activedIconSrc = '/images/poi_icon_popup_mss.png'
      break
    default:
      it.iconSrc = ''
      it.activedIconSrc = ''
  }
  it.point = [it.lng, it.lat]
}

export function parseNetworkPoint(it: any): void {
  const distance = it.distance || 0
  let dis: number
  if (it.distance > 1000) {
    dis = parseNumber(it.distance / 1000, 1)
    it.dis = dis.toString() + 'km'
  } else {
    dis = parseNumber(it.distance, 0)
    it.dis = dis.toString() + 'm'
  }
  if (it.label_name) {
    it.labelName = it.label_name
  }
  it.evaluation = parseNumber(it.evaluation || 0, 1).toFixed(1)
  switch (it.sub_type) {
    // 自营服务站
    case 'after_sales':
      it.subTypeName = '直营服务站'
      it.subTypeTagText = '直营'
      it.subTypeTagBgColor = '#F85359'
      break
    // 移动服务站
    case 'after_sales_car':
      it.subTypeName = '移动服务站'
      it.subTypeTagText = '移动'
      it.subTypeTagBgColor = '#F9C303'
      break
    // 授权服务站
    case 'auth_warehouse':
      it.subTypeName = '授权服务站'
      it.subTypeTagText = '授权'
      it.subTypeTagBgColor = '#1991EB'
      break
    default:
      it.subTypeName = '未知类型网点'
      it.subTypeTagText = ''
      it.subTypeTagBgColor = ''
  }
}

export function parseTrainNetworkPointtItem(it: any): void {
  it.id = it.guid
  switch (it.type_text) {
    // 自营服务站
    case '直属培训网点':
      it.iconSrc = '/images/poi_icon_dss.png'
      it.activedIconSrc = '/images/poi_icon_popup_dss.png'
      break
    // 授权服务站
    case '授权培训网点':
      it.iconSrc = '/images/poi_icon_mss.png'
      it.activedIconSrc = '/images/poi_icon_popup_mss.png'
      break
    default:
      it.iconSrc = ''
      it.activedIconSrc = ''
  }
  it.point = [it.lng, it.lat]
}


export function parseTrainNetworkPoint(it: any): void {
  let dis: number
  if (it.distance > 1000) {
    dis = parseNumber(it.distance / 1000, 1)
    it.dis = dis.toString() + '公里'
  } else {
    dis = parseNumber(it.distance, 0)
    it.dis = dis.toString() + '米'
  }
  switch (it.type_text) {
    // 直营培训网点
    case '直属培训网点':
      it.subTypeName = '直属培训网点'
      it.subTypeFontColor = '#39B54A'
      break
    // 授权培训网点
    case '授权培训网点':
      it.subTypeName = '授权培训网点'
      it.subTypeFontColor = '#1991EB'
      break
    default:
      it.subTypeName = '未知类型培训网点'
      it.subTypeFontColor = 'rgba(0, 0, 0, 0.66)'
  }
}